import { render, staticRenderFns } from "./DsSwitch.vue?vue&type=template&id=679008fe&scoped=true&"
import script from "./DsSwitch.vue?vue&type=script&lang=js&"
export * from "./DsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DsSwitch.vue?vue&type=style&index=0&id=679008fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679008fe",
  null
  
)

export default component.exports